import {
    COLUMN_TYPE,
    COLUMN_NAME,
    COLUMN_ENABLED,
    COLUMN_EMAIL_SUBJECT,
    COLUMN_FREQUENCY,
    COLUMN_TIME,
    COLUMN_SEND_TO_RECIPIENTS,
    COLUMN_DETAILS, COLUMN_ACCOUNT,
    COLUMN_CREATED_BY
} from "../../constants/column-types";
import { TableColumn } from "../table/TableColumn";

const NotificationColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "name",
        sortDirection: "asc",
        active: true,
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        heading: "Type",
        accessor: "vruleDisplayType",
        isNumeric: false,
        id: 1,
        sortByName: "vruleDisplayType.trnName",
        sortDirection: "asc",
        active: true,
        translationKey: "type",
        columnId: COLUMN_TYPE,
        searchOnName: "vruleDisplayType.id",
        isDefault: true,
    },
    {
        heading: "Frequency",
        accessor: "frequence",
        isNumeric: true,
        id: 2,
        sortByName: "frequence",
        active: true,
        translationKey: "frequence",
        isDefault: true,
        columnId: COLUMN_FREQUENCY
    },
    {
        heading: "Time",
        accessor: "time",
        isNumeric: false,
        id: 3,
        active: true,
        translationKey: "time",
        isDefault: true,
        columnId: COLUMN_TIME
    },
    {
        heading: "Email Subject",
        accessor: "emailSubject",
        isNumeric: false,
        id: 4,
        active: true,
        translationKey: "emailSubject",
        isDefault: true,
        columnId:COLUMN_EMAIL_SUBJECT
    },
    {
        heading: "Send To Recipient",
        accessor: "toRecipientsConcat",
        isNumeric: false,
        id: 5,
        active: true,
        translationKey: "sendToRecipients",
        isDefault: true,
        columnId: COLUMN_SEND_TO_RECIPIENTS
    },
    {
        heading: "Details",
        accessor: "detailsConcat",
        isNumeric: false,
        id: 6,
        active: true,
        translationKey: "details",
        isDefault: true,
        columnId:COLUMN_DETAILS
    },
    {
        heading: "Account",
        accessor: "accountName",
        isNumeric: false,
        id: 7,
        sortByName: "accountName",
        searchOnName: "accountId",
        active: false,
        translationKey: "account",
        isDefault: false,
        columnId:COLUMN_ACCOUNT
    },
    {
        heading: "Enabled",
        accessor: "vruleEnabled",
        isNumeric: false,
        id: 8,
        sortByName: "vruleEnabled",
        active: false,
        translationKey: "enabled",
        isDefault: false,
        columnId: COLUMN_ENABLED,
    },
    {
        heading: "Author",
        accessor: "authorName",
        isNumeric: false,
        id: 9,
        sortByName: "authorName",
        active: false,
        translationKey: "author",
        isDefault: false,
        columnId: COLUMN_CREATED_BY
    }
];

export default NotificationColumns;
